export default __webpack_public_path__ + "static/media/FincantieriSI_GrimaldiCruises.61d5bfe8.pdf";